import api from '@/api/index.js'

const pt_mapping = {
  state: {
    loading: false,
    updating: false,
    data: [],
    error: null,
    vehicleTypes: ['bus', 'trolleybus', 'tram', 'funicular', 'train', 'boat', 'ferry'],
  },

  mutations: {
    SET_PT_MAPPINGS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_PT_MAPPINGS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_MAPPINGS: (state, data) => {
      state.data = data;
      state.loading = false;
    },
    SET_PT_MAPPINGS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
    SET_PT_MAPPINGS_DELETED: (state, deleted) => {
      state.data = state.data.filter(item => item.id != deleted.id);
      state.updating = false;
    },
    SET_PT_MAPPINGS_UPDATED: (state, updated) => {
      let objIndex = state.data.findIndex((obj => obj.id == updated.id));

      if (objIndex >= 0) {
        state.data[objIndex].created_at = updated.created_at;
        state.data[objIndex].updated_at = updated.updated_at;
        state.data[objIndex].id = updated.id;
        state.data[objIndex].operator_id = updated.operator_id;
        state.data[objIndex].garage_number = updated.garage_number;
        state.data[objIndex].mapping_id = updated.mapping_id;
        state.data[objIndex].vehicle_type = updated.vehicle_type;
        state.data[objIndex].created_by = updated.created_by;
        state.data[objIndex].modified_by = updated.modified_by;
      }
      state.updating = false;
    },
  },

  actions: {
    LoadPTMappings({commit}) {
      commit('SET_PT_MAPPINGS_ERROR', null)
      commit('SET_PT_MAPPINGS_LOADING', true)
      return api.get('pt-mappings?limit=0&offset=0')
        .then((response) => {
          commit('SET_MAPPINGS', response)
        }).catch((error) => {
          commit('SET_PT_MAPPINGS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    CreatePTMapping({commit}, payload) {
      commit('SET_PT_MAPPINGS_UPDATING', true);
      commit('SET_ERROR', null);
      commit('SET_PT_MAPPINGS_ERROR', null)
      return api.post(`pt-mappings`, payload)
        .then((response) => {
          commit('SET_PT_MAPPINGS_UPDATING', false);
        }).catch((error) => {
          commit('SET_PT_MAPPINGS_ERROR', error)
          commit('SET_PT_MAPPINGS_UPDATING', false);
        })
    },
    UpdatePTMapping({commit}, payload) {
      commit('SET_PT_MAPPINGS_UPDATING', true);
      commit('SET_ERROR', null);
      commit('SET_PT_MAPPINGS_ERROR', null)
      return api.put(`pt-mappings/${payload.id}`, payload)
        .then((response) => {
          commit('SET_PT_MAPPINGS_UPDATED', response.body)
        }).catch((error) => {
          commit('SET_PT_MAPPINGS_ERROR', error)
          commit('SET_PT_MAPPINGS_UPDATING', false)
        })
    },
    DeletePTMapping({commit}, payload) {
      commit('SET_PT_MAPPINGS_UPDATING', true);
      commit('SET_ERROR', null);
      commit('SET_PT_MAPPINGS_ERROR', null)
      return api.delete(`pt-mappings/${payload.id}`)
        .then((response) => {
          commit('SET_PT_MAPPINGS_DELETED', payload)
        })
        .catch((error) => {
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_PT_MAPPINGS_ERROR', error)
          commit('SET_PT_MAPPINGS_UPDATING', false);
        })
    }
  }
}

export default pt_mapping
